import { Legend, Space } from './styles'

export function InputLabel({ children }) {
  return (
    <>
      <Space>{children}</Space>
      <Legend>{children}</Legend>
    </>
  )
}
